<div
  [ngClass]="
    !question.isCustom ? 'dropdown-question-label' : 'question-label-as-intro'
  "
>
  {{ question.label }}
</div>

<mat-table
  class="table-questions"
  [dataSource]="tableSource"
  *ngIf="question.value.length > 0"
>
  <ng-container [matColumnDef]="column" *ngFor="let column of question.columns">
    <mat-header-cell *matHeaderCellDef> {{ column }} </mat-header-cell>
    <mat-cell *matCellDef="let row">
      {{ row[column] }}
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef></mat-header-cell>
    <mat-cell *matCellDef="let fields; let i = index">
      <button mat-icon-button type="button" (click)="onDeleteItem(i)">
        <mat-icon matTooltip="delete row" matTooltipPosition="left" color="warn"
          >delete</mat-icon
        >
      </button>
    </mat-cell>
  </ng-container>
  <mat-header-row *matHeaderRowDef="tableDisplayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: tableDisplayedColumns"></mat-row>
</mat-table>

<div
  class="table"
  fxLayout="row wrap"
  fxLayoutAlign="start center"
  fxLayout.lt-sm="column"
  fxLayoutGap="20px grid"
>
  <mat-form-field
    [fxFlex]="25"
    [fxFlex.sm]="100"
    *ngFor="let column of question.columns"
    appearance="fill"
  >
    <mat-label class="address-question-label">
      {{ column }}
    </mat-label>
    <input
      matInput
      type="text"
      [id]="column"
      [name]="column"
      [formControl]="formGroup.controls[column]"
      [required]="question.required && question.value.length === 0"
    />
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <button
    type="button"
    [fxFlex]="25"
    [fxFlex.sm]="100"
    class="mb-15"
    mat-icon-button
    color="primary"
    (click)="addToTable()"
  >
    <mat-icon matTooltip="Add to table" matTooltipPosition="left">add</mat-icon>
    Add to table
  </button>
</div>
